import React, { useEffect } from "react";
import { navigate } from "@reach/router";
import { useUser } from "../hooks/useApi";

import { getRadioEntryPath } from "../features/entryFlow/entryIntentStorage";

const PrivateRoute = ({ component: Component, location, ...rest }) => {
  const { logged, initiated, setLoginRedirect } = useUser();

  useEffect(() => {
    console.log("PrivateRoute", location.pathname);
    (async () => {
      if (!logged && location.pathname !== `/app` && initiated) {
        console.log("navigate to home");
        const matchSonicbox = location.pathname.match(/\/sonicbox\/(.*)?/);
        if (matchSonicbox) {
          window.localStorage.setItem(
            "redirectLogin",
            `/sonicbox/${matchSonicbox[1]}`
          );
          setLoginRedirect(`/sonicbox/${matchSonicbox[1]}`);
        }
        await navigate(getRadioEntryPath() || "/");
      }
    })();
  }, [logged, location, rest, initiated, setLoginRedirect]);

  if (logged) {
    return <Component {...rest} />;
  }
  return null;
};

export default PrivateRoute;
